import React from 'react';
import arrayMutators from 'final-form-arrays';

import PageBaseProps from 'types/PageBase';
import FormKeys from 'modules/form/types/FormKeys';

import ConnectedForm from 'components/ui/ConnectedForm';

import MobilityError from './MobilityError';
import MobilityDocumentFormRender from './MobilityDocumentFormRender';

const MobilityDocumentForm: React.FC<PageBaseProps> = ({ onNext, ...pageProps }) => (
  <ConnectedForm
    onSubmit={onNext}
    keepDirtyOnReinitialize
    formKey={FormKeys.MOBILITY}
    mutators={{ ...arrayMutators }}
    errorComponent={<MobilityError />}
    component={MobilityDocumentFormRender}
    subscription={{ errors: true }}
    {...pageProps}
  />
);

export default MobilityDocumentForm;
